const STORAGE_PREFIX = "dtiq_recent_reports";
const MAX_RECENT = 5;

const storageKey = (userKey) =>
  `${STORAGE_PREFIX}:${userKey || "anon"}`;

export const getRecentReports = (userKey) => {
  try {
    const raw = localStorage.getItem(storageKey(userKey));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((item) => item && item.id != null && item.name)
      .slice(0, MAX_RECENT);
  } catch {
    return [];
  }
};

/**
 * Push a report to the front of the recent list (max 5, deduped by id).
 * @returns {Array} updated list
 */
export const pushRecentReport = (userKey, report) => {
  if (!report?.id) return getRecentReports(userKey);
  const entry = {
    id: report.id,
    name: report.name || `Report ${report.id}`,
    type: report.type || null,
    visitedAt: Date.now(),
  };
  const prev = getRecentReports(userKey).filter(
    (item) => String(item.id) !== String(entry.id)
  );
  const next = [entry, ...prev].slice(0, MAX_RECENT);
  try {
    localStorage.setItem(storageKey(userKey), JSON.stringify(next));
  } catch {
    // ignore quota / private mode
  }
  return next;
};

export const RECENT_REPORTS_MAX = MAX_RECENT;
